import { JWT_ACCESS_TOKEN, USER_INFO } from '~/src/constants/common'
import useAuthStore from '~/stores/auth'

const whiteList = ['/login', '/reset-password', '/set-password']

export default defineNuxtRouteMiddleware(async (to) => {
  const { $cookies } = useNuxtApp()
  const jwtToken = $cookies.get(JWT_ACCESS_TOKEN)
  const user = $cookies.get(USER_INFO)
  const authStore = useAuthStore()
  const isAuthenticated = jwtToken && user
  const isWhiteList = whiteList.includes(to.path)

  if (!isAuthenticated && isWhiteList) return
  if (!isAuthenticated && !isWhiteList) return navigateTo('/login')

  if (isAuthenticated && isWhiteList)
    return navigateTo('/price-dashboard/chart-builder')

  if (to.path === '/') return navigateTo('/price-dashboard/chart-builder')

  authStore.setJwtToken(jwtToken)
  authStore.setUser(user)
})
